/* eslint-disable */

(function ($) {
    $.widget('ep.checkbox_list_record_input_field', $.ep.base_record_field, {
        options: {
            templateId: 'edit-record-checkbox-input-field'
        },

        setValues: function () {
            var values = this._model.Values;
            var checkBoxItems = $(".record-checkbox-input-field", this.element);

            checkBoxItems.each(function (i) {
                $(this).prop("checked", $.inArray($(this).val(), values) > -1);
            });
        },

        getData: function () {
            var values = [];
            $(".record-checkbox-input-field:checked", this.element).each(function (i, element) {
                values.push($(element).val());
            });

            this._model.Values = values;

            return this._model;
        },

        afterRenderTemplate: function () {
            let _this = this;

            // :not(.red) --> react only on non removed fields changes
            $('.item-group-label:not(.red)', this.element).each(function(i, x) {
                $(x).change(function () {
                    // update Values
                    _this.getData();
                    _this.updateBranchVisibility();
                });
            });

            this.setValidationRules();
        },

        setValidationRules: function () {
            if ($(".record-checkbox-input-field", this.element).length > 0) {
                $(".record-checkbox-input-field", this.element).rules("add",
                    {
                        required: this.options.model.Required,
                        minlength: 1,
                        messages: {
                            required: this.options.resources.validationRequired
                        }
                    });
            }
        },
    });
})(jQuery);

/* eslint-enable */
